/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "rewards": {
                "nested": {
                  "SeriesData": {
                    "fields": {
                      "monthlyValues": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "totalEarned": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.SeriesData) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SeriesData @ squareup/corporate_card/resources/rewards/series_data.proto at 7:1
 */
export const SeriesData = $root.lookupType('squareup.corporate_card.resources.rewards.SeriesData');
fixType(SeriesData);
Builder.createAndAttachToType(SeriesData);